import { useCallback, useState } from "react";
import { getService } from "../../services/axios/services";
import _ from "lodash";

function buildHierarchy(localities) {
  const mapById = new Map(localities.map((loc) => [loc.id, loc]));

  return localities.map((loc) => {
    const parent = loc.parentId ? mapById.get(loc.parentId) : null;

    return {
      value: loc.id,
      label: loc.name,
      data: loc,
      parentHierarchy: parent ? parent.name : null,
      remissives: [],
    };
  });
}

export default function useLocalities() {
  const [localities, setLocalities] = useState(null);

  const fetchLocalities = useCallback(async () => {
    if (localities) return;

    const response = await getService({ endpoint: `location/filter` });
    if (!response?.data) return;

    const sortedData = _.sortBy(response.data, [
      (loc) => loc.name.toLowerCase(),
    ]);

    const enrichedData = buildHierarchy(sortedData);

    setLocalities(enrichedData);
  }, [localities]);

  const refreshLocalities = useCallback(() => {
    setLocalities(null);
  }, []);

  return {
    localities,
    fetchLocalities,
    refreshLocalities,
  };
}
